import axios from 'axios';
import store from '.';

const axiosInstance = axios.create({ withCredentials: true });

const MAX_RETRIES = 3;

axiosInstance.interceptors.request.use((config) => {
  const _token = store.state.authentication?.loggedInUser?.token;
  if (_token) {
    config.headers.Authorization = `Bearer ${_token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => { return response },
  async (error) => {
    const { config } = error;

    if (!config || config.__retryCount >= MAX_RETRIES) {
      return Promise.reject(error);
    }

    config.__retryCount = (config.__retryCount || 0) + 1;

    console.warn(`Retrying request (${config.__retryCount}/${MAX_RETRIES})...`);

    await new Promise((resolve) => { return setTimeout(resolve, 1000) });

    return axiosInstance(config);
  },
);

export default axiosInstance;
